import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, AbstractControl, Validators } from '@angular/forms';

import { Store } from '@ngrx/store';

import { ToastrService } from 'ngx-toastr';

import { ReleaseNote } from 'src/app/models/release-note';
import { removeWhitespaces } from 'src/app/core/custom-form-validators';
import { ReleaseNoteState } from '../../state/release-note/release-note.reducer';
import { saveReleaseNote, editReleaseNote } from '../../state/release-note/release-note.actions';

@Component({
  selector: 'dashboard-create-release-note-dialog',
  templateUrl: './create-release-note-dialog.component.html',
  styleUrls: ['./create-release-note-dialog.component.scss'],
})
export class CreateReleaseNoteDialogComponent implements OnInit {
  releaseNoteForm: FormGroup;

  tags = {
    updates: false,
    regular: false,
    careercompass: false,
  };

  isEdit = false;

  constructor(
    private formBuilder: FormBuilder,
    private store: Store<ReleaseNoteState>,
    private toastrService: ToastrService,
    @Inject(MAT_DIALOG_DATA)
    public data: { key: number; releaseNote: ReleaseNote }
  ) {}

  ngOnInit(): void {
    this.releaseNoteForm = this.formBuilder.group({
      title: ['', [Validators.required, removeWhitespaces]],
      description: ['', [Validators.required, removeWhitespaces]],
    });
    if (this.data && this.data.releaseNote) {
      this.isEdit = true;
      this.tags.updates = !!this.data.releaseNote.updates;
      this.tags.regular = !!this.data.releaseNote.regular;
      this.tags.careercompass = !!this.data.releaseNote.careercompass;
    }
  }

  get title(): AbstractControl {
    return this.releaseNoteForm.get('title');
  }

  get description(): AbstractControl {
    return this.releaseNoteForm.get('description');
  }

  updateUpdates() {
    this.tags.updates = !this.tags.updates;
  }

  updateTiim() {
    this.tags.regular = !this.tags.regular;
  }

  updateCC(): void {
    this.tags.careercompass = !this.tags.careercompass;
  }

  submitReleaseNote(): void {
    if (!this.isFormComplete()) {
      this.toastrService.info('Unable to save release note without title, description and at least one tag');
      return;
    }
    const releaseNote: ReleaseNote = {
      title: this.title.value,
      description: this.description.value,
    };

    for (const tag in this.tags) {
      if (this.tags.hasOwnProperty(tag) && this.tags[tag]) {
        releaseNote[tag] = true;
      } else {
        releaseNote[tag] = false;
      }
    }
    if (!this.isEdit) {
      this.store.dispatch(saveReleaseNote({ releaseNote }));
      this.resetForm();
    } else {
      releaseNote.id = this.data.releaseNote.id;
      this.store.dispatch(editReleaseNote({ releaseNote }));
    }
  }

  resetForm(): void {
    this.releaseNoteForm.reset();
    for (const tag in this.tags) {
      if (this.tags.hasOwnProperty(tag)) {
        this.tags[tag] = false;
      }
    }
  }

  isFormComplete(): boolean {
    if (
      this.releaseNoteForm.invalid ||
      (this.tags.updates === false && this.tags.regular === false && this.tags.careercompass === false)
    ) {
      return false;
    }
    return true;
  }
}
